export const HomeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["Organization", "Corporation"],
      "@id": "https://navatel.ir/#organization",
      "name": "نواتل",
      "alternateName": ["Navatel", "شبکه گستران آریا سامانه"],
      "legalName": "شرکت مهندسی شبکه گستران آریا سامانه",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "@id": "https://navatel.ir/#logo",
        "url": "https://navatel.ir/_ipx/q_80&s_150x72/img/logo-modal.webp",
        "width": 150,
        "height": 72,
        "caption": "لوگوی رسمی نواتل"
      },
      "image": {
        "@id": "https://navatel.ir/#logo"
      },
      "description": "شرکت مهندسی شبکه گستران آریا سامانه ارائه‌دهنده سرویس ارتباطات یکپارچه ابری (UCaaS) با برند نواتل شامل مرکز تلفن ابری، مرکز تماس ابری، CRM، تلفن گویای هوشمند، پنل پیامکی، فکس اینترنتی و خطوط ویژه مخابراتی.",
      "telephone": "+98-21-82800000",
      "email": "office@sgas.ir",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "خیابان شریعتی، سه‌راه طالقانی، ابتدای خیابان خواجه نصیرالدین طوسی، پلاک ۲۴۷، ساختمان نواتل",
        "addressLocality": "تهران",
        "addressRegion": "تهران",
        "postalCode": "1611613611",
        "addressCountry": "IR"
      },
      "identifier": [
        {
          "@type": "PropertyValue",
          "name": "شناسه ملی اشخاص حقوقی",
          "value": "10102221071"
        },
        {
          "@type": "PropertyValue",
          "name": "شناسه کسب‌وکار",
          "value": "179232654798"
        }
      ],
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+98-21-82800000",
          "contactType": "customer service",
          "areaServed": "IR",
          "availableLanguage": ["fa", "en"]
        },
        {
          "@type": "ContactPoint",
          "telephone": "+98-21-82800000",
          "contactType": "technical support",
          "areaServed": "IR",
          "availableLanguage": ["fa"]
        }
      ],
      "sameAs": [
        "https://www.wikidata.org/wiki/Q141341326",
        "https://www.crunchbase.com/organization/navatel",
        "https://www.linkedin.com/company/mynavatel/",
        "https://www.instagram.com/navatel.ir/",
        "https://www.youtube.com/channel/UCxe7nEw65vIIez3gbt1Xc4g",
        "https://t.me/navatelir"
      ],
      "knowsAbout": [
        "مرکز تلفن ابری (Cloud PBX)",
        "مرکز تماس ابری (Cloud Contact Center)",
        "سیستم ارتباطات یکپارچه (UCaaS)",
        "VoIP",
        "CRM ابری",
        "تلفن گویای هوشمند (IVR)",
        "پنل پیامکی",
        "خطوط اختصاصی مخابراتی"
      ],
      "hasCredential": [
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "پروانه ارائه خدمات ارتباطی ثابت (Servco)",
          "recognizedBy": {
            "@type": "GovernmentOrganization",
            "name": "سازمان تنظیم مقررات و ارتباطات رادیویی"
          }
        },
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "پروانه بهره‌برداری تولید نرم‌افزار",
          "recognizedBy": {
            "@type": "GovernmentOrganization",
            "name": "وزارت صنعت، معدن و تجارت"
          }
        },
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "گواهی صلاحیت خدمات انفورماتیکی",
          "recognizedBy": {
            "@type": "GovernmentOrganization",
            "name": "سازمان برنامه و بودجه کشور"
          }
        },
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "مجوز فعالیت نظام صنفی رایانه‌ای",
          "recognizedBy": {
            "@type": "Organization",
            "name": "سازمان نظام صنفی رایانه‌ای استان تهران"
          }
        },
        {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "گواهی تأیید فنی نرم‌افزار",
          "recognizedBy": {
            "@type": "GovernmentOrganization",
            "name": "وزارت فرهنگ و ارشاد اسلامی"
          }
        }
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://navatel.ir/#website",
      "url": "https://navatel.ir/",
      "name": "نواتل",
      "alternateName": "Navatel",
      "description": "نواتل تنها سرویس ارتباطات یکپارچه ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران.",
      "inLanguage": "fa-IR",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      }
    },
    {
      "@type": "WebPage",
      "@id": "https://navatel.ir/#webpage",
      "url": "https://navatel.ir/",
      "name": "نواتل | مرکز تلفن ابری، CRM و پنل پیامکی یکپارچه",
      "description": "پلتفرم ابری نواتل؛ ارائه‌دهنده مرکز تلفن ابری، خطوط اینترنتی، CRM، پیام‌رسان سازمانی و چت آنلاین بدون نیاز به سخت‌افزار.",
      "isPartOf": {
        "@id": "https://navatel.ir/#website"
      },
      "about": {
        "@id": "https://navatel.ir/#organization"
      },
      "primaryImageOfPage": {
        "@id": "https://navatel.ir/#logo"
      },
      "inLanguage": "fa-IR"
    },
    {
      "@type": "SoftwareApplication",
      "@id": "https://navatel.ir/#application",
      "name": "اپلیکیشن اختصاصی نواتل",
      "operatingSystem": "Android, iOS, Windows, Linux, Web",
      "applicationCategory": "BusinessApplication",
      "description": "نرم‌افزار مدیریت ارتباطات سازمانی، تماس اینترنتی، چت آنلاین و مدیریت CRM روی موبایل و دسکتاپ.",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "IRR",
        "availability": "https://schema.org/InStock"
      }
    },
    {
      "@type": "Service",
      "@id": "https://navatel.ir/#service-cloud-pbx",
      "name": "مرکز تلفن ابری نواتل (Cloud PBX)",
      "serviceType": "تلفن ابری سازمانی و VoIP",
      "provider": {
        "@id": "https://navatel.ir/#organization"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Iran"
      },
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "کسب‌وکارهای کوچک، متوسط و سازمان‌های بزرگ"
      },
      "description": "راهکارهای تلفن اینترنتی و منشی گویا بدون نیاز به تجهیزات سخت‌افزاری و دفتر فیزیکی."
    }
  ]
}
